export const AGREEMENTS = {
  crypto_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/Crypto%20Customer%20Agreement.pdf",
    revision: "02.17.2023",
  },
  alpacax_crypto_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/Crypto%20Customer%20Agreement.pdf",
    revision: "02.17.2023",
  },
  customer_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf",
    revision: "23.2025.05",
  },
  options_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/ALPACA+SECURITIES+LLC++OPTIONS+AGREEMENT.pdf",
    revision: "01.2024.01",
  },
  msla_agreement: {
    url: "https://files.alpaca.markets/disclosures/Alpaca_Master+Securities+Lending+Agreement+for+Fully+Paid+Securities+Lending_v01.2025.03.pdf",
    revision: "01.2025.03",
  },
  consent_to_collateral_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/ConsentToCollateralAdministrationAgreement.pdf",
  },
  equity_trust_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/Equity+Trust+Company+Trust+Agreement.pdf",
  },
  limited_margin_agreement: {
    url: "https://files.alpaca.markets/disclosures/library/MarginDiscStmt.pdf",
  },
} as const;

export type AgreementId = keyof typeof AGREEMENTS;
